import { Component, OnDestroy, OnInit } from "@angular/core";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { forkJoin } from "rxjs";
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { AssetService } from 'src/app/_services/asset.service';

@Component({
  selector: "app-add-asset-status",
  standalone: false,
  templateUrl: "./add-asset-status.component.html",
  styleUrl: "./add-asset-status.component.scss",
})
export class AddAssetStatusComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  defaultColor: string = "#FFFFFF";
  assetTypeAssignments = [];
  assetTypeAssignmentsSpliced = []; //first 10 records to show in UI

  data: any;
  statusCategories: any = [];
  statusInfoForm: FormGroup;
  assetTypes: any;
  profiles: any;
  statusInfo: any;
  showAllJobTypes: boolean = false;
  addonFeature: any;

  constructor(
    public modalRef: BsModalRef,
    private globalJOServc: GlobalJobordersService,
    private languageTranslateService: LanguageTranslateService,
    private errorUtil: ErrorUtil,
    private bsModalServc: BsModalService,
    private auth: AuthenticationService,
    private assetService: AssetService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.statusCategories = this.data.categories;

    this.defaultColor = "#FFFFFF"; //this.generateBrightColorHex();
    this.statusInfoForm = new FormGroup({
      statusCategory: new FormControl("", Validators.required),
      statusLabel: new FormControl("", Validators.required),
      statusCode: new FormControl("", Validators.required),
      statusColor: new FormControl(this.defaultColor, Validators.required),
      defaultColor: new FormControl(this.defaultColor),
      assetType: new FormControl([]),
    });

    if (this.data.mode) {
      if (!this.data.from) {
        //statusData
        this.statusInfoForm.patchValue({
          statusCategory: this.data.statusData.category,
          statusLabel: this.data.statusData.label,
          statusCode: this.data.statusData.code,
          statusColor: this.data.statusData.color,
          defaultColor: this.data.statusData.color
        });
      } else {
        //from picklist
        this.statusInfoForm.patchValue({
          statusCategory: this.data.statusData.statusGroup,
          statusLabel: this.data.statusData.label,
          statusCode: this.data.statusData.code,
          statusColor: this.data.statusData.colorCode,
          defaultColor: this.data.statusData.colorCode,
        });
      }
    }

    let sources = [
      this.assetService.getTypes('active')
    ];

    if (this.data.mode) {
      //edit mode
      let statusId: any = this.data.from
        ? this.data.statusData.id
        : this.data.statusData.joStatusId;
      sources.push(this.assetService.getStatusByIdV2(statusId));
    }

    this.push(forkJoin(sources).subscribe(
      ([assetTypeResponse, assetStatusResponse]) => {
        let types: any = assetTypeResponse.body;
        this.assetTypes = types;
        this.statusInfo = assetStatusResponse?.body;

        if (!this.data.mode) {
          //create mode
          let foundIdx = this.assetTypes.findIndex((item: any) => {
            return item.id === this.data.joTypeId;
          });
          if (foundIdx >= 0) {
            this.assetTypeAssignments.push(this.assetTypes[foundIdx]);
            this.assetTypes.splice(foundIdx, 1);
          }
        } else {
          //edit mode
          this.statusInfo?.assetsType.map((joType: any) => {
            let idx: number = this.assetTypes.findIndex((item: any) => {
              return item.id === joType.id;
            });
            if (idx >= 0) {
              this.assetTypeAssignments.push(this.assetTypes[idx]);
              this.assetTypes.splice(idx, 1);
            }
          });
        }
        //show first 10 records only. Show all when toggle to cilck Show More
        this.assetTypeAssignmentsSpliced = this.assetTypeAssignments.slice(0, 10);
      },
      (error: any) => {
        console.log(error, "error in forkJoin printing..");
      },
    ));
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onColorPickerChange(event: any) {
    this.statusInfoForm.patchValue({ statusColor: event.value });
  }

  removeAssetType(itemToRemove: any, index: number) {
    this.assetTypeAssignments.splice(index, 1);
    //find the index in assetTypeAssignmentsSpliced to remove
    let idx: number = this.assetTypeAssignmentsSpliced.findIndex((jt: any) => {
      return jt.id === itemToRemove.id;
    });
    if (idx >= 0) {
      this.assetTypeAssignmentsSpliced.splice(idx, 1);
    }
    //add back to the list
    this.assetTypes.push(itemToRemove);
  }

  onAddAssetType() {
    // this.assetTypeAssignments = [];
    let selectedJOTypes: any = this.statusInfoForm.get("assetType")?.value;
    //selectedJOTypes.map ((jo: any) =>{
    let foundIdx = this.assetTypes.findIndex((item: any) => {
      return item.id === selectedJOTypes;
    });
    this.assetTypeAssignments.push(this.assetTypes[foundIdx]);
    //take first 10 records if show more toggle is NOT on (To prevent assetTypeAssignmentsSpliced to get refreshed in UI)
    if (!this.showAllJobTypes) {
      this.assetTypeAssignmentsSpliced = this.assetTypeAssignments.slice(0, 10);
    }
    this.statusInfoForm.controls["assetType"].reset();
    //remove it from the list after added
    this.assetTypes.splice(foundIdx, 1);
    //})
  }

  onFormSubmit() {
    if (this.statusInfoForm.valid) {
      const selectedAssetTypes = this.assetTypeAssignments.map((item) => ({
        id: item.id,
        name: item.name,
      }));


      if (!this.data.mode) {
        //create
        let payload: any = {
          assetsStatus: {
            code: this.statusInfoForm.get("statusCode")?.value, //code
            label: this.statusInfoForm.get("statusLabel")?.value,
            name: this.statusInfoForm.get("statusLabel")?.value,
            active: true,
            systemValue: false,
            isDefault:
              this.statusInfoForm.get("statusCategory")?.value == "SCHEDULED"
                ? true
                : false,
            colorCode: this.statusInfoForm.get("statusColor")?.value,
            statusGroup: this.statusInfoForm.get("statusCategory")?.value,
            order: this.data.statusOrder
          },
          assetsType: selectedAssetTypes,
        };
        
        this.push(this.assetService.createAssetStatus(payload).subscribe(
          (res: any) => {
            if (res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                "Status added successfully",
                null,
                "success",
                3000,
              );

              let jsonObj: any = {
                id: res.body[0]?.assetsStatus?.id,
                reason: "status-added",
              };
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          (err: any) => {
            // handle error here
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        ));
      } else {
        //update
        let payload = {
          assetsStatus: {
            id: this.data.from ? this.data.statusData.id : this.data.statusData.joStatusId,
            name: this.statusInfoForm.get("statusLabel")?.value,
            code: this.statusInfoForm.get("statusCode")?.value,
            label: this.statusInfoForm.get("statusLabel")?.value,
            order: this.statusInfo.assetsStatus.order,
            colorCode: this.statusInfoForm.get("statusColor")?.value,
            isDefault: this.data.statusData.isDefault,
            active: true,
            systemValue: this.data.statusData.systemValue,
            statusGroup: this.statusInfoForm.get("statusCategory")?.value,
          },
          assetsType: selectedAssetTypes,
        };

        this.push(this.assetService.updateAssetStatus(payload, payload.assetsStatus.id ).subscribe(
          (res: any) => {
            if (res.status == 200) {
              this.errorUtil.setErrorMessage(
                200,
                "Status updated successfully",
                null,
                "success",
                3000,
              );

              let jsonObj: any = {
                id: res.body[0]?.assetsStatus?.id,
                reason: "status-updated",
              };
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
              this.modalRef.hide();
            }
          },
          (err: any) => {
            // handle error here
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        ));
      }
    } else {
      this.statusInfoForm.markAllAsTouched();
    }
  }

  onCancelClick() {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }

  onLabelChange() {
    let statusLabelValue = this.statusInfoForm.get("statusLabel")?.value;
    let formattedLabel = statusLabelValue
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "_");
    this.statusInfoForm.patchValue({
      statusCode: formattedLabel,
    });
  }

  generateBrightColorHex() {
    let color = "#";
    // Ensure at least one component is high for brightness
    const highValue = 200 + Math.floor(Math.random() * 56); // 200-255
    const lowValue = Math.floor(Math.random() * 100); // 0-99

    const components = [highValue, lowValue, lowValue];
    // Shuffle the components to randomize which one is high
    components.sort(() => Math.random() - 0.5);

    for (let i = 0; i < 3; i++) {
      let hex = components[i].toString(16);
      color += hex.length === 1 ? "0" + hex : hex;
    }
    return color;
  }

  onShowMoreToggle(category: string) {
    if (category == "assetType") {
      this.showAllJobTypes = !this.showAllJobTypes;
      if (this.showAllJobTypes === true) {
        this.assetTypeAssignmentsSpliced = this.assetTypeAssignments;
      } else {
        this.assetTypeAssignmentsSpliced = this.assetTypeAssignments.slice(
          0,
          10,
        );
      }
    } else {
    }
  }
}
